"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const calendar_1 = require("@kyruus/calendar");
require("./date-range-modal.css");
const styles_1 = require("../styles");
const moment_1 = __importDefault(require("moment"));
const isOutsideRange = () => false;
const DateRangeFilter = ({ column, showLabel = false, tableId, isLoading = false }) => {
    const { filterValue, setFilter, id, render, filterLabel } = column;
    const [focusedInput, setFocusedInput] = react_1.default.useState(null);
    const [dateRange, setDateRange] = react_1.default.useState(filterValue ? filterValue : { startDate: null, endDate: null });
    if (filterValue && typeof filterValue.startDate == 'string')
        filterValue.startDate = (0, moment_1.default)(filterValue.startDate);
    if (filterValue && typeof filterValue.endDate == 'string')
        filterValue.endDate = (0, moment_1.default)(filterValue.endDate);
    const inputInfo = filterLabel || `Filter by ${render('Header')}`;
    const filterLabelId = `filter-date-range-label-${tableId}-${id}`;
    const filterIdStart = `filter-date-range-start-${tableId}-${id}`;
    const filterIdEnd = `filter-date-range-end-${tableId}-${id}`;
    const filterId = `${filterIdStart} ${filterIdEnd}`;
    return (react_1.default.createElement("span", { "data-testid": "date-range-filter", role: "presentation", onClick: (e) => {
            e.stopPropagation();
        } },
        showLabel ? (react_1.default.createElement(styles_1.FilterLabel, { id: filterLabelId, htmlFor: filterId }, inputInfo)) : (react_1.default.createElement(styles_1.HiddenFilterLabel, { id: filterLabelId, htmlFor: filterId }, inputInfo)),
        react_1.default.createElement(calendar_1.DateRangePicker, { showClearDates: true, disabled: isLoading, isOutsideRange: isOutsideRange, hideKeyboardShortcutsPanel: true, startDate: dateRange.startDate, startDateId: filterIdStart, endDate: dateRange.endDate, endDateId: filterIdEnd, onDatesChange: (newDateRange) => {
                setDateRange(newDateRange);
                if (newDateRange.startDate == null && newDateRange.endDate == null) {
                    setFilter(undefined);
                }
                else {
                    setFilter(newDateRange);
                }
            }, focusedInput: focusedInput, onFocusChange: (focusedInput) => {
                setFocusedInput(focusedInput);
            } })));
};
exports.default = DateRangeFilter;
//# sourceMappingURL=DateRangeFilter.js.map